<template>
	<div class="home">
		<nav-bar :title="current_video_name" :askUrl="current_video_ask" @openWithHbuilder="openWithHbuilder" @toggleSideBar="toggleSideBar"></nav-bar>
		<div class="content" :class="{showSideBar:showSideBar}">
			<video-box :url="current_video_url" @ended="videoEnded"></video-box>
		</div>
		<side-bar :title="title" :show="showSideBar" :list="lesson_list" :current="current" @setCurrent="setCurrent"></side-bar>
		<modal ref="modal" @confirm="openHbuilderLink"></modal>
	</div>
</template>

<script>
	// @ is an alias to /src
	import NavBar from '@/components/NavBar.vue'
	import SideBar from '@/components/SideBar.vue'
	import VideoBox from '@/components/VideoBox.vue'
	import Modal from '@/components/Modal.vue'
	import cookieUtil from '@/utils/cookie.js'

	export default {
		name: 'home',
		components: {
			NavBar,
			SideBar,
			VideoBox,
			Modal
		},
		data() {
			return {
				title: 'Vue.js 教程',
				lesson_list: [{
					name: '序言 vue.js介绍',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_00.mp4',
					ask: '77367'
				}, {
					name: '第1节 安装与部署',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_01.mp4',
					ask: '77369'
				}, {
					name: '第2节 创建第一个vue应用',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_02.mp4',
					ask: '77370'
				}, {
					name: '第3节 数据与方法',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_03.mp4',
					ask: '77372'
				}, {
					name: '第4节 生命周期',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_04.mp4',
					ask: '77373'
				}, {
					name: '第5节 模板语法-插值',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_05.mp4',
					ask: '77375'
				}, {
					name: '第6节 模板语法-指令',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_06.mp4',
					ask: '77376'
				}, {
					name: '第7节 class与style绑定',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_07.mp4',
					ask: '77377'
				}, {
					name: '第8节 条件渲染',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_08.mp4',
					ask: '77378'
				}, {
					name: '第9节 列表渲染',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_09.mp4',
					ask: '77380'
				}, {
					name: '第10节 事件绑定',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_10.mp4',
					ask: '77381'
				}, {
					name: '第11节 表单输入绑定',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_11.mp4',
					ask: '77382'
				}, {
					name: '第12节 组件基础',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_12.mp4',
					ask: '77383'
				}, {
					name: '第13节 组件注册',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_13.mp4',
					ask: '78520'
				}, {
					name: '第14节 单文件组件',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_14.mp4',
					ask: '78521'
				}, {
					name: '第15节 免终端开发vue应用',
					url: 'https://dcloud-chjh-learning.oss-cn-hangzhou.aliyuncs.com/video/chapter_16.mp4',
					ask: '81004',
					downUrl: 'hbuilderx://ext/download?plugin=%7B%22id%22%3A%22DCloud-vuejs-learning-15%22%2C%22name%22%3A%22vue.js%5Cu6559%5Cu7a0b-%5Cu7b2c15%5Cu8282%20%5Cu514d%5Cu7ec8%5Cu7aef%5Cu5f00%5Cu53d1vue%5Cu5e94%5Cu7528%22%2C%22version%22%3A%221.0.0%22%2C%22category_name%22%3A%22%5Cu9879%5Cu76ee%5Cu6a21%5Cu677f%22%2C%22category_code%22%3A%22projecttemplate%22%2C%22download_url%22%3A%22http%3A%5C%2F%5C%2Fext-resource-aliyun.dcloud.net.cn%5C%2Fmarketplace%5C%2Fb53a9fb0-f3aa-11e9-87e2-dd990eecd704%5C%2Fplugin_ide.zip%3Fv%3D1571625688%22%2C%22size%22%3A%2210.1KB%22%2C%22description%22%3A%22DCloud%5Cu51fa%5Cu54c1%5Cu7684vue.js%5Cu6559%5Cu7a0b%20%5Cu7b2c15%5Cu8282%20%5Cu514d%5Cu7ec8%5Cu7aef%5Cu5f00%5Cu53d1vue%5Cu5e94%5Cu7528%22%7D'
				}],
				current: 0,
				showSideBar: true,
				downUrl: 'hbuilderx://ext/download?plugin=%7B%22id%22%3A%22DCloud-vuejs-learning%22%2C%22name%22%3A%22vue.js%5Cu6559%5Cu7a0b%22%2C%22version%22%3A%221.0.1%22%2C%22category_name%22%3A%22web%20%5Cu9879%5Cu76ee%5Cu6a21%5Cu677f%22%2C%22category_code%22%3A%22web-project-template%22%2C%22download_url%22%3A%22http%3A%5C%2F%5C%2Fext-resource-aliyun.dcloud.net.cn%5C%2Fmarketplace%5C%2F502c92e0-be54-11e9-b6f9-656b7ac73b68%5C%2Fplugin.zip%3Fv%3D1565842682%22%2C%22size%22%3A%2290.6KB%22%2C%22description%22%3A%22DCloud%5Cu51fa%5Cu54c1%5Cu7684vue.js%5Cu6559%5Cu7a0b%22%7D'
			}
		},
		computed: {
			current_video() {
				return this.lesson_list[this.current]
			},
			current_video_name() {
				return this.current_video.name
			},
			current_video_url() {
				return this.current_video.url
			},
			current_video_ask() {
				return 'https://ask.dcloud.net.cn/question/' + this.current_video.ask
			},
			current_video_downUrl() {
				return this.current_video.downUrl || this.downUrl
			}
		},
		created() {
			this.current = parseInt(this.$route.query.vid || 0)
			if (this.current >= this.lesson_list.length || this.current < 0) {
				this.current = 0
			}
		},
		methods: {
			toggleSideBar() {
				this.showSideBar = !this.showSideBar
			},
			setCurrent(index) {
				this.current = index
				this.$router.replace({
					query: {
						vid: index
					}
				})
			},
			openWithHbuilder() {
				// eslint-disable-next-line
				if (_hmt) {
					// eslint-disable-next-line
					_hmt.push(['_trackEvent', 'Link', 'toHBuilderX', '使用HBuilderX实操课程源码']);
				}
				let HBuilderXInstallHint = cookieUtil.getCookie("HBuilderXInstallHint");
				if (HBuilderXInstallHint) {
					this.openHbuilderLink()
				} else {
					this.$refs.modal.show()
				}
			},
			openHbuilderLink() {
				// eslint-disable-next-line
				if (_hmt) {
					// eslint-disable-next-line
					_hmt.push(['_trackEvent', 'Code', 'download', '使用HBuilderX导入源码']);
				}
				cookieUtil.setCookie("HBuilderXInstallHint", true, 365)
				location.href = this.current_video_downUrl
			},
			videoEnded() {
				this.$msgBox.showMsgBox({
					text: '看完视频，开始动手实践一下吧',
					confirmButton: '使用HX打开课程源码'
				}).then(() => {
					this.openWithHbuilder()
				}).catch(() => {

				})
			}
		}
	}
</script>

<style scoped>
	.home {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
	}

	.content {
		position: absolute;
		top: 60px;
		bottom: 0;
		left: 0;
		right: 0;
	}

	.content.showSideBar {
		left: 350px;
	}
</style>
